var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { commonUrl } from "@adapters/infrastructures/urlConfig/SalesJourney/common";
import { removeObjectValues } from "@frameworks/salesjourney/components/Features/LeadDashboard/constant";
import { connvertFrmPartnerResponseIntoEntity } from "@domains/salesFeatures/Common/mapper/FrmPartnerlistMapper";
var FilterDataRepository = /** @class */ (function () {
    function FilterDataRepository(http) {
        this.http = http;
    }
    FilterDataRepository.prototype.getPreferencesData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, preferencesData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(commonUrl.Preferences);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        preferencesData = _a.sent();
                        return [2 /*return*/, preferencesData];
                }
            });
        });
    };
    FilterDataRepository.prototype.getEntityTypeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, entityType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(commonUrl.entityType);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        response = _a.sent();
                        entityType = {
                            entityTypeData: response.data,
                        };
                        return [2 /*return*/, entityType];
                }
            });
        });
    };
    FilterDataRepository.prototype.getDisplaySchemeData = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, registerationData, bucketEntity;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(commonUrl.displayName);
                        if (req.searchText)
                            url.searchParams.append("searchText", req.searchText);
                        if (req.displayId !== null && req.displayId !== undefined)
                            url.searchParams.append("displayId", req.displayId.toString());
                        if (req.bucketId !== undefined && req.bucketId !== 0)
                            url.searchParams.append("bucketId", req.bucketId.toString());
                        if (req.productId !== undefined && req.productId !== 0)
                            url.searchParams.append("productId", req.productId.toString());
                        if (req.categoryId !== undefined && req.categoryId !== 0) {
                            url.searchParams.append("categoryId", req.categoryId.toString());
                        }
                        !!req.issuerId &&
                            url.searchParams.append("issuerId", req.issuerId.toString());
                        if (req.bucketlst && req.bucketlst.length > 0)
                            url.searchParams.append("bucketlst", req.bucketlst.join(","));
                        !!req.issuerId &&
                            url.searchParams.append("issuerId", req.issuerId.toString());
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", (_a = req === null || req === void 0 ? void 0 : req.focus) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                signal: req.abortSignal,
                            })];
                    case 1:
                        registerationData = _c.sent();
                        bucketEntity = {
                            displaySchemeNameList: [],
                        };
                        if (((_b = registerationData === null || registerationData === void 0 ? void 0 : registerationData.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            bucketEntity.displaySchemeNameList = registerationData.data;
                            bucketEntity.filterData = registerationData.data;
                        }
                        return [2 /*return*/, bucketEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getRegistrationData = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, registerationData, bucketEntity;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(commonUrl.RegistrationProduct);
                        url.searchParams.append("bucket", req.bucketArray.join(","));
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req.leadFlag !== null &&
                            req.leadFlag !== undefined &&
                            req.leadFlag !== "") {
                            url.searchParams.append("leadflag", req.leadFlag);
                        }
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", (_a = req === null || req === void 0 ? void 0 : req.focus) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        registerationData = _c.sent();
                        bucketEntity = {
                            bucketList: [],
                        };
                        if (((_b = registerationData === null || registerationData === void 0 ? void 0 : registerationData.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            bucketEntity.bucketList = registerationData.data;
                        }
                        return [2 /*return*/, bucketEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getPotentialTierData = function (req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var url, potentialTierDataResponse, potentialTierData, dataObj;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        url = new URL(commonUrl.potentialTier);
                        url.searchParams.append("clienttype", req.clientType);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        potentialTierDataResponse = _d.sent();
                        potentialTierData = [];
                        if (((_b = (_a = potentialTierDataResponse === null || potentialTierDataResponse === void 0 ? void 0 : potentialTierDataResponse.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            potentialTierData = (_c = potentialTierDataResponse === null || potentialTierDataResponse === void 0 ? void 0 : potentialTierDataResponse.data) === null || _c === void 0 ? void 0 : _c.result;
                        }
                        dataObj = {
                            data: potentialTierData,
                        };
                        return [2 /*return*/, dataObj];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSubCategoryAll = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, leadStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.SubCategoryAll);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        leadStatus = {
                            leadSubCategoryList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            leadStatus.leadSubCategoryList = sourceData.data;
                            leadStatus.filterData = sourceData.data;
                        }
                        return [2 /*return*/, leadStatus];
                }
            });
        });
    };
    FilterDataRepository.prototype.getDSAClientEmployeeData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, extPartData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.DSAClientEmployee);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("flag", req.flag);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        extPartData = _b.sent();
                        if (((_a = extPartData === null || extPartData === void 0 ? void 0 : extPartData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            return [2 /*return*/, extPartData.data.map(function (x) {
                                    return {
                                        id: x.id,
                                        name: x.masterValue,
                                    };
                                })];
                        }
                        return [2 /*return*/, []];
                }
            });
        });
    };
    FilterDataRepository.prototype.getLeadStatus = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, leadStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.LeadStatus);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        leadStatus = {
                            leadStatusList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            leadStatus.leadStatusList = sourceData.data;
                            leadStatus.filterData = sourceData.data;
                        }
                        return [2 /*return*/, leadStatus];
                }
            });
        });
    };
    FilterDataRepository.prototype.getStatusData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, sourceEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.Status);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("bucketid", req.BucketId.toString());
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        sourceEntity = {
                            statusList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            sourceEntity.statusList = sourceData.data;
                            sourceEntity.filterData = sourceData.data;
                        }
                        return [2 /*return*/, sourceEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSubStatusData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, sourceEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.SubStatus);
                        url.searchParams.append("statusid", req.statusid.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        sourceEntity = {
                            subStatusList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            sourceEntity.subStatusList = sourceData.data;
                        }
                        return [2 /*return*/, sourceEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSubSourceData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, sourceEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.subSources);
                        url.searchParams.append("sourceId", req.sourceId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        sourceEntity = {
                            subSourcesList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            sourceEntity.subSourcesList = sourceData.data;
                        }
                        return [2 /*return*/, sourceEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSourceData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceData, sourceEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.source);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        sourceData = _b.sent();
                        sourceEntity = {
                            sourceList: [],
                        };
                        if (((_a = sourceData === null || sourceData === void 0 ? void 0 : sourceData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            sourceEntity.sourceList = sourceData.data;
                        }
                        return [2 /*return*/, sourceEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSubCategoryData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, categoryData, categoryEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.subCategory);
                        url.searchParams.append("CategoryId", req.CategoryId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        categoryData = _b.sent();
                        categoryEntity = {
                            data: [],
                        };
                        if (((_a = categoryData === null || categoryData === void 0 ? void 0 : categoryData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            categoryEntity.data = categoryData.data;
                        }
                        return [2 /*return*/, categoryEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getBucketData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, bucketData, bucketEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.bucket);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", req.focus.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        bucketData = _b.sent();
                        bucketEntity = {
                            bucketData: [],
                        };
                        if (((_a = bucketData === null || bucketData === void 0 ? void 0 : bucketData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            bucketEntity.bucketData = bucketData.data;
                            bucketEntity.filterData = bucketData.data;
                        }
                        return [2 /*return*/, bucketEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getInteractionStatusData = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, status_1, interactionStatus, interactionStatusEntity;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(commonUrl.interactionStatus);
                        if ((req === null || req === void 0 ? void 0 : req.statusid) || ((_a = req === null || req === void 0 ? void 0 : req.interactionStatusId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            url = new URL(commonUrl.interactionSubStatus);
                            if (req.statusid)
                                url.searchParams.append("statusid", req.statusid === null ? null : req.statusid.toString());
                            if (req.interactionStatusId.length > 0) {
                                status_1 = "";
                                status_1 = req.interactionStatusId.join(",");
                                // url.searchParams.append("statusid",);
                                url.searchParams.append("status", status_1);
                            }
                            else {
                                url.searchParams.append("status", "null");
                            }
                        }
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        interactionStatus = _c.sent();
                        interactionStatusEntity = {
                            interactionStatusList: [],
                        };
                        if (((_b = interactionStatus === null || interactionStatus === void 0 ? void 0 : interactionStatus.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            interactionStatusEntity.filterData = interactionStatus.data;
                        }
                        interactionStatusEntity.interactionStatusList = interactionStatus.data;
                        return [2 /*return*/, interactionStatusEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getCategoryData = function (req) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var url, categoryData, categoryEntity;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(commonUrl.category);
                        url.searchParams.append("ProductId", req.ProductId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req.focus)
                            url.searchParams.append("focus", (_a = req === null || req === void 0 ? void 0 : req.focus) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        categoryData = _c.sent();
                        categoryEntity = {
                            data: [],
                        };
                        if (((_b = categoryData === null || categoryData === void 0 ? void 0 : categoryData.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                            categoryEntity.data = categoryData.data;
                        }
                        return [2 /*return*/, categoryEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getProductData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, productData, productEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.product);
                        url.searchParams.append("BucketId", req === null || req === void 0 ? void 0 : req.BucketId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", req.focus.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        productData = _b.sent();
                        productEntity = {
                            productList: [],
                        };
                        if (((_a = productData === null || productData === void 0 ? void 0 : productData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            productEntity.productList = productData.data;
                        }
                        return [2 /*return*/, productEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getTierData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, tierResult, tierResultEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(commonUrl.tierData);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        tierResult = _a.sent();
                        tierResultEntity = {
                            filterData: [],
                        };
                        // let tierResult = JSON.parse(tierDataJson);
                        tierResultEntity.filterData = tierResult.data;
                        return [2 /*return*/, tierResultEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getPartnersListOfLoggedInFRM = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.partners);
                        if ((req === null || req === void 0 ? void 0 : req.filterData) !== null && (req === null || req === void 0 ? void 0 : req.filterData) !== undefined) {
                            req.filterData = removeObjectValues(req.filterData, /Lst/);
                            url.searchParams.append("filterData", encodeURI(JSON.stringify(req.filterData)));
                        }
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("PageSize", req.pageSize.toString());
                        url.searchParams.append("searchText", (_a = req === null || req === void 0 ? void 0 : req.searchText) !== null && _a !== void 0 ? _a : "");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, connvertFrmPartnerResponseIntoEntity(result)];
                }
            });
        });
    };
    FilterDataRepository.prototype.getFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, localReqObj, filterData, filterEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.filterUrl);
                        localReqObj = JSON.parse(JSON.stringify(req));
                        localReqObj.filterData = removeObjectValues(localReqObj.filterData, /Lst/);
                        url.searchParams.append("filterData", encodeURI(JSON.stringify(localReqObj.filterData)));
                        url.searchParams.append("page", localReqObj.page);
                        url.searchParams.append("pageSize", localReqObj.pageSize);
                        (localReqObj === null || localReqObj === void 0 ? void 0 : localReqObj.searchText)
                            ? url.searchParams.append("searchText", localReqObj.searchText)
                            : null;
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        filterData = _b.sent();
                        filterEntity = {
                            filterData: [],
                        };
                        if (((_a = filterData === null || filterData === void 0 ? void 0 : filterData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            filterEntity.filterData = filterData.data;
                        }
                        return [2 /*return*/, filterEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSchemeFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, schemeData, schemeEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL("api/Scheme");
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        schemeData = _b.sent();
                        schemeEntity = {
                            schemefilterData: [],
                        };
                        if (((_a = schemeData === null || schemeData === void 0 ? void 0 : schemeData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            schemeEntity.schemefilterData = schemeData.data;
                        }
                        return [2 /*return*/, schemeEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSubCatByScheme = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, schemeData, subCategoryData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.catSubCatbyDisplay);
                        url.searchParams.append("displayId", req.displayId.toString());
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req === null || req === void 0 ? void 0 : req.focus)
                            url.searchParams.append("focus", (_a = req.focus) === null || _a === void 0 ? void 0 : _a.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        schemeData = _b.sent();
                        subCategoryData = [];
                        if (schemeData.data.length > 0) {
                            subCategoryData = schemeData.data;
                        }
                        return [2 /*return*/, subCategoryData];
                }
            });
        });
    };
    FilterDataRepository.prototype.getSchemeByCategory = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, schemeData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(commonUrl.displayNameByCategory);
                        url.searchParams.append("categoryid", req.categoryId.toString());
                        if (req.searchText)
                            url.searchParams.append("searchText", req.searchText);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        schemeData = _a.sent();
                        return [2 /*return*/, schemeData.data];
                }
            });
        });
    };
    FilterDataRepository.prototype.getExtPartFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, extPartData, extPartEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.ExternalParticipants);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req.searchText !== null &&
                            req.searchText !== undefined &&
                            req.searchText !== "") {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        extPartData = _b.sent();
                        extPartEntity = {
                            extPartfilterData: [],
                        };
                        if (((_a = extPartData === null || extPartData === void 0 ? void 0 : extPartData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            extPartEntity.extPartfilterData = extPartData.data;
                        }
                        return [2 /*return*/, extPartEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getParticipantsFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, participantsData, participantsEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.Participants);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        if (req.searchText !== null &&
                            req.searchText !== undefined &&
                            req.searchText !== "") {
                            url.searchParams.append("searchText", req.searchText);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        participantsData = _b.sent();
                        participantsEntity = {
                            participantsfilterData: [],
                        };
                        if (((_a = participantsData === null || participantsData === void 0 ? void 0 : participantsData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            participantsEntity.participantsfilterData = participantsData.data;
                        }
                        return [2 /*return*/, participantsEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getStandardRespData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, stnrespData, stnrespEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.StandardResponseNew);
                        if ((req === null || req === void 0 ? void 0 : req.BucketId) !== null && (req === null || req === void 0 ? void 0 : req.BucketId) !== undefined) {
                            url.searchParams.append("bucketId", req.BucketId.toString());
                        }
                        if ((req === null || req === void 0 ? void 0 : req.productId) !== null && (req === null || req === void 0 ? void 0 : req.productId) !== undefined) {
                            url.searchParams.append("productId", req.productId.toString());
                        }
                        if ((req === null || req === void 0 ? void 0 : req.categoryId) !== null && (req === null || req === void 0 ? void 0 : req.categoryId) !== undefined) {
                            url.searchParams.append("categoryId", req.categoryId.toString());
                        }
                        url.searchParams.append("subCategoryID", req.subCategoryId.toString());
                        url.searchParams.append("statusID", req.statusId.toString());
                        if ((req === null || req === void 0 ? void 0 : req.substatusID) !== null && (req === null || req === void 0 ? void 0 : req.substatusID) !== undefined) {
                            url.searchParams.append("subStatusId", req.substatusID.toString());
                        }
                        if ((req === null || req === void 0 ? void 0 : req.page) !== null && (req === null || req === void 0 ? void 0 : req.page) !== undefined && (req === null || req === void 0 ? void 0 : req.page) !== "") {
                            url.searchParams.append("page", req.page);
                        }
                        if ((req === null || req === void 0 ? void 0 : req.pageSize) !== null &&
                            (req === null || req === void 0 ? void 0 : req.pageSize) !== undefined &&
                            (req === null || req === void 0 ? void 0 : req.pageSize) !== "") {
                            url.searchParams.append("pageSize", req.pageSize);
                        }
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        stnrespData = _b.sent();
                        stnrespEntity = {
                            standardResponses: [],
                        };
                        if (((_a = stnrespData === null || stnrespData === void 0 ? void 0 : stnrespData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            stnrespEntity.standardResponses = stnrespData.data;
                        }
                        return [2 /*return*/, stnrespEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getCustomerTypeFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, customerTypeData, customerTypeEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.CustomerType);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize); //  let profileData =
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        customerTypeData = _b.sent();
                        customerTypeEntity = {
                            customerTypes: [],
                        };
                        if (((_a = customerTypeData === null || customerTypeData === void 0 ? void 0 : customerTypeData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            customerTypeEntity.customerTypes = customerTypeData.data;
                            customerTypeEntity.filterData = customerTypeData.data;
                        }
                        return [2 /*return*/, customerTypeEntity];
                }
            });
        });
    };
    FilterDataRepository.prototype.getTypeOfContactFilterData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, typeOfContactData, typeOfContact;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(commonUrl.TypeOfContact);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize); //  let profileData =
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        typeOfContactData = _b.sent();
                        typeOfContact = {
                            typeOfContacts: [],
                        };
                        if (((_a = typeOfContactData === null || typeOfContactData === void 0 ? void 0 : typeOfContactData.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            typeOfContact.typeOfContacts = typeOfContactData.data;
                            typeOfContact.filterData = typeOfContactData.data;
                        }
                        return [2 /*return*/, typeOfContact];
                }
            });
        });
    };
    FilterDataRepository.prototype.validateFocus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(commonUrl.validateFocus);
                        headers = new Headers();
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                                headers: headers,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return FilterDataRepository;
}());
export default FilterDataRepository;
